import { render, staticRenderFns } from "./OrderStatusSteps.vue?vue&type=template&id=6d5a91d2&scoped=true&"
import script from "./OrderStatusSteps.vue?vue&type=script&lang=js&"
export * from "./OrderStatusSteps.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusSteps.vue?vue&type=style&index=0&id=6d5a91d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a91d2",
  null
  
)

export default component.exports